<template>
  <div>
    <div v-if="!messages.length">
      <p>(there aren&apos;t any yet)</p>
    </div>
    <div v-for="msg in messages"
         :key="msg.uuid">
      <div class="level" style="margin-bottom: 0.3rem;">
        <div class="level-left">
          <div class="level-item has-text-weight-bold">
            {{ msg.title }}
          </div>
        </div>
        <div class="level-right">
          <div class="level-item has-text-weight-bold">
            {{ msg.date }}
          </div>
        </div>
      </div>
      <hr style="margin-top: 0.3rem; margin-bottom: 0.3rem;" />
      <div v-html="msg.html_content"></div>
      <br /><br /><br /><br />
    </div>
  </div>
</template>

<script>
export default {
    name: 'MessageList',
    props: {
        messageType: Number,
    },
    data() {
        return {
            messages: [],
        }
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // go ahead and fetch data if someone is logged in
            if (this.$store.state.user.uuid) {
                this.fetchData()
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            let params = {
                // we only want messages of a certain type
                filters: JSON.stringify([
                    {field: 'type_code', op: 'eq', value: this.messageType},
                ]),
                sort: 'date|desc',
            }
            this.$http.get('/api/mgmt-messages', {params: params}).then(response => {
                // console.log(response.data)
                this.messages = response.data.data
            }, response => {
                this.$buefy.toast.open({
                    message: "Failed to load data:  (unknown error)",
                    type: 'is-danger',
                    duration: 4000, // 4 seconds
                })
            })
        },
    },

}
</script>
